import { TopCollectionCardProps } from './TopCollectionCard';

export const topCollectionCardMock: TopCollectionCardProps = {
  name: 'Chelik',
  floorPrice: 100,
  volumeTraded: '1000',
  avatar: 'https://dota2ok.ru/wp-content/uploads/2021/09/1ab84456ddaeffa8495f3a5218adc550.jpg',
};
